import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BasePageComponent } from './components/base-page/base-page.component';

@NgModule({
  declarations: [BasePageComponent],
  imports: [CommonModule],
  exports: [BasePageComponent],
})
export class BasePageModule {}
